import React from 'react';
import { Box } from '@mui/material';

import Typography from 'src/components/ui/Typography';
import Icon from 'src/components/ui/Icon';

interface Props {
    text: string;
}

const NoFavoritesEmptyState: React.FC<Props> = ({ text }) => (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="10rem">
        <Icon name="NoFavorites" style={{ height: '6.5rem', width: '5rem' }} />
        <Box mt="1.5rem" width="8.5rem" textAlign="center">
            <Typography variant="body2">{text}</Typography>
        </Box>
    </Box>
);

export default NoFavoritesEmptyState;
